import { Link } from "react-router-dom";

const linkGroups = [
  {
    title: "浏览内容",
    links: [
      { label: "官方正版渠道", to: "/#official" },
      { label: "漫画分类", to: "/#categories" },
      { label: "精选推荐", to: "/#featured" },
      { label: "追更指南", to: "/articles" },
    ],
  },
  {
    title: "帮助中心",
    links: [
      { label: "常见问题", to: "/faq" },
      { label: "关于我们", to: "/about" },
      { label: "联系我们", to: "/contact" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="border-t border-background-200 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-12 md:px-6 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-4">
          <div className="md:col-span-2">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-lg bg-primary-500 text-background-50">
                <i className="ri-bubble-chart-line text-lg"></i>
              </span>
              <span className="font-comic text-lg">正版韩漫大全</span>
            </div>
            <p className="mt-4 max-w-md text-sm leading-relaxed text-foreground-600">
              一个专注整理正版韩漫官方入口、正版授权与独家内容的聚合导航网站。我们只收录公开标注授权关系的官方平台，帮你快速找到想看的韩漫，避开盗版站，追更更省心。
            </p>
            <div className="mt-5 flex flex-wrap gap-2">
              <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">官方正版</span>
              <span className="rounded-full bg-secondary-100 px-3 py-1 text-xs text-secondary-900">授权渠道</span>
              <span className="rounded-full bg-accent-100 px-3 py-1 text-xs text-accent-900">独家内容</span>
            </div>
          </div>

          {linkGroups.map((group) => (
            <div key={group.title}>
              <h4 className="text-sm font-semibold text-foreground-900">{group.title}</h4>
              <ul className="mt-4 space-y-3">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.to}
                      className="whitespace-nowrap text-sm text-foreground-600 transition-colors hover:text-primary-600"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 flex flex-col items-start justify-between gap-4 border-t border-background-200 pt-6 sm:flex-row sm:items-center">
          <p className="text-xs text-foreground-500">
            © {new Date().getFullYear()} 正版韩漫大全 · 本网站仅收录正版授权渠道，尊重每一位创作者。
          </p>
          <div className="flex flex-wrap gap-4 text-xs text-foreground-500">
            <a href="#" className="transition-colors hover:text-primary-600" rel="nofollow">免责声明</a>
            <a href="#" className="transition-colors hover:text-primary-600" rel="nofollow">版权说明</a>
            <a href="#" className="transition-colors hover:text-primary-600" rel="nofollow">隐私政策</a>
          </div>
        </div>
      </div>
    </footer>
  );
}